import React from "react";
import LogoBar from "./nav/logoBar";
import MainNavBar from "./nav/mainNavBar";
import MainTabs from "./nav/mainTabs";

import Copyright from "./_common/Copyright";

/*
 * Layout Component
 *  Global (app-level) layout of components.
 *  Also contains modals that need to be available globally.
 *  This component is to remain stateless - all global state-dependent
 *  functions are to be defined and implemented in MainSwitch, which
 *  consumes this component and provides any necessary props.
 */
export default (props) => (
  <div className="dms-app">
    <div className="no-print">
      <LogoBar fetching={props.fetching} />
      <MainNavBar
        toggleAdrSearchModal={props.toggleAdrSearchModal}
        toggleReportSelectionModal={props.toggleReportSelectionModal}
        toggleCreateAdrFromExistingModal={props.toggleCreateAdrFromExistingModal}
        toggleProjAssignmentProjSelectionModal={
          props.toggleProjAssignmentProjSelectionModal
        }
        toggleLoginModal={props.toggleLoginModal}
        toggleAlert_logoutConfirm={props.toggleAlert_logoutConfirm}
      />
      <MainTabs />
    </div>
    <div className="tab-content tab-content-main-module mx-1">
      {props.children}
      <div className="no-print">
        <Copyright />
      </div>
    </div>
  </div>
);
